'use client';

import Script from 'next/script';

import { getENV } from '../../utils/env';

export const AfterPayLegacy = () => {
    return <Script data-testid="square-script" src={getENV('NEXT_PUBLIC_AFTERPAY_SCRIPT_URL')} async />;
};
